module.exports = __webpack_public_path__ + "media/10.1edecd82.mp3";